/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import axios from 'axios';
import { API } from './Define';

// ponytail: in-flight dedup + recent ok cache; covers duplicate_request without touching exitApp callers
const inflight = new Map();
const recentOk = new Map();
const DEDUP_TTL = 5000;

const requestKey = (method, url, token, payload) =>
  `${method}:${url}:${token}:${JSON.stringify(payload)}`;

const resolveFetch = (key, data, resolve) => {
  if (data?.status === 'ok') {
    recentOk.set(key, { data, at: Date.now() });
  }
  resolve(data);
};

export const FetchData = (mothod, url, token, payload = {}, isFormData = false) => {
  const key = requestKey(mothod, url, token, payload);
  if (inflight.has(key)) {
    return inflight.get(key);
  }

  const promise = new Promise((resolve, reject) => {
    axios(API + url, {
      headers: {
        ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
        Authorization: `Bearer ${token}`,
      },
      method: mothod,
      data: payload,
      timeout: 300000,
    })
      .then((res) => {
        const { data } = res;
        if (data?.msg === 'duplicate_request') {
          const cached = recentOk.get(key);
          if (cached && Date.now() - cached.at < DEDUP_TTL) {
            resolve(cached.data);
            return;
          }
        }
        resolveFetch(key, data, resolve);
      })
      .catch(function (error) {
        reject(error);
      })
      .finally(() => {
        inflight.delete(key);
      });
  });

  inflight.set(key, promise);
  return promise;
};

export const FetchURL = (mothod, url, token, payload = {}, isFormData = false) => {
  return new Promise((resolve, reject) => {
    axios(url, {
      headers: {
        ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
        Authorization: `Bearer ${token}`,
      },
      method: mothod,
      data: payload,
      timeout: 300000,
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

export const PostData = (url, payload = {}) => {
  return new Promise((resolve, reject) => {
    axios(API + url, {
      headers: { 'Content-Type': 'application/json' },
      method: 'post',
      data: payload,
      timeout: 300000,
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};
